module.exports = __webpack_public_path__ + "static/media/hall-P4.3b83afe9.svg";